import type { Dispatch, SetStateAction } from 'react';
import { Heading } from '@/components/Heading';
import { Form } from '@/components/Form';
import { TextField } from '@/components/TextField';
import { useValidation } from '@/contexts/validationContext';
import { doNothingOnSubmit } from '@/utils/doNothingOnSubmit';
import { ValidationSectionKey } from '@/constants';

interface StoreFilterProps {
  filter: string;
  setFilter: Dispatch<SetStateAction<string>>;
}

export const StoreFilter = ({ filter, setFilter }: StoreFilterProps) => {
  const { clearValidationError, errorMessages } = useValidation();

  const handleChange = (value: string) => {
    clearValidationError(ValidationSectionKey.ClickAndCollectStoreId);
    setFilter(value);
  };

  return (
    <>
      <Heading level={2}>Find your nearest store</Heading>
      <Form
        className={
          errorMessages.storeSelection ? 'has-validation-error' : undefined
        }
        handleSubmit={doNothingOnSubmit}
        validationErrors={errorMessages}
      >
        <TextField
          label="Town / County / Postal code"
          name={ValidationSectionKey.ClickAndCollectStoreId}
          onChange={handleChange}
          value={filter}
        />
      </Form>
    </>
  );
};
